import { render, staticRenderFns } from "./search_compound.vue?vue&type=template&id=6ba7b9d4"
import script from "./search_compound.vue?vue&type=script&lang=js"
export * from "./search_compound.vue?vue&type=script&lang=js"
import style0 from "./search_compound.vue?vue&type=style&index=0&id=6ba7b9d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports